__turbopack_context__.v({
  "className": "open_sans_9fffa912-module__53jIVq__className",
  "variable": "open_sans_9fffa912-module__53jIVq__variable",
});
